export const membershipMetricOptions = [
  {
    name: "Status",
    id: "status",
    metric: "NumberOfMembersByStatus"
  },
  {
    name: "ClubReady Profile",
    id: "clubReadyProfile",
    metric: "NumberOfMembersByProfile"
  },
  {
    name: "Paying",
    id: "paying",
    metric: "NumberOfPayingMembersByPricingOption"
  },
  {
    name: "Paying Excluding Zero Sales",
    id: "payingExcludingZeroSales",
    metric: "NumberOfPayingMembersByPricingOptionExcludingZeroSales"
  },
  {
    name: "Membership Type",
    id: "membershipType",
    metric: "MembersByMembershipType"
  }
];

export const MEMBERSHIP_METRIC_MAPPING = {
  NumberOfMembersByStatus: {
    availableOptions: [
      "Status",
      "ClubReady Profile",
      "Paying",
      "Paying Excluding Zero Sales",
      "Membership Type"
    ],
    selectedOptionByDefault: "Status"
  },
  NumberOfMembersByProfile: {
    availableOptions: ["ClubReady Profile"],
    selectedOptionByDefault: "ClubReady Profile"
  },
  NumberOfPayingMembersByPricingOption: {
    availableOptions: [
      "Status",
      "ClubReady Profile",
      "Paying",
      "Paying Excluding Zero Sales",
      "Membership Type"
    ],
    selectedOptionByDefault: "Paying"
  },
  NumberOfPayingMembersByPricingOptionExcludingZeroSales: {
    availableOptions: [
      "Status",
      "ClubReady Profile",
      "Paying",
      "Paying Excluding Zero Sales",
      "Membership Type"
    ],
    selectedOptionByDefault: "Paying Excluding Zero Sales"
  }
};

export const METRIC_PARAMS = {
  NumberOfMembersByStatus: {
    apiPath: "number_of_active_members_by_status",
    showPosModal: true,
    showLearnText: true
  },
  NumberOfMembersByProfile: {
    apiPath: "number_of_active_members_by_profile",
    showPosModal: false,
    showLearnText: true
  },
  NumberOfPayingMembersByPricingOption: {
    apiPath: "number_of_members_paying_by_pricing_option",
    showPosModal: true,
    showLearnText: false
  },
  NumberOfPayingMembersByPricingOptionExcludingZeroSales: {
    apiPath: "number_of_members_paying_by_pricing_option_excluding_zero_sales",
    showPosModal: true,
    showLearnText: false
  },
  MembersByMembershipType: {
    apiPath: "members_by_membership_type",
    showPosModal: false,
    showLearnText: true
  }
};
